module.exports = __webpack_public_path__ + "img/MEDIA119.85c5def9.jpg";